import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { triggerPoll } from '../api';

export default function RefreshButton() {
  const qc = useQueryClient();
  const [spinning, setSpinning] = useState(false);

  async function onClick() {
    if (spinning) return;
    setSpinning(true);
    try {
      await triggerPoll();
      await qc.invalidateQueries();
    } finally {
      setTimeout(() => setSpinning(false), 600);
    }
  }

  return (
    <button
      onClick={onClick}
      disabled={spinning}
      className="tab-link inline-flex items-center justify-center w-9 h-9 rounded-lg bg-ink-800 text-chalk hover:bg-ink-700 active:bg-ink-600 disabled:opacity-60"
      aria-label="Refresh"
      title="Refresh"
    >
      <svg
        width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        className={spinning ? 'animate-spin' : ''}
      >
        <polyline points="23 4 23 10 17 10" />
        <polyline points="1 20 1 14 7 14" />
        <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
      </svg>
    </button>
  );
}
